define('glu/grid/filter/badges/auxControl',['require','../../../itemView','hbs!./auxControl.hbs'],function(require) {
    'use strict';

    var ItemView = require('../../../itemView'),
        tpl = require('hbs!./auxControl.hbs');

    return ItemView.extend({
        template: tpl,
        className: 'aux-control',

        events: {
            'click .js-clear-filters': 'clearFilters'
        },

        collectionEvents: {
            'grid:filter:change': 'updateFilters'
        },

        initialize: function() {
            this.filterProc = this.options.filterProc;
            this.filters = this.filterProc.filters || [];

            this.filtersCollection = this.filterProc.filters;

            if (!this.filtersCollection) {
                return;
            }

            this.listenTo(this.filtersCollection, 'refresh', this.updateFilters);
        },

        templateHelpers: function() {
            return {
                filtersEnabled: this.filters.length
            };
        },

        updateFilters: function() {
            this.filters = this.filterProc.filters || [];

            this.render();
        },

        clearFilters: function(e) {
            e.preventDefault();

            this.filterProc.clear();
        }
    });
});

